// src/components/Universals/CustomerService/supportChatButton.component.jsx
import React, { useEffect, useMemo, useState, useCallback } from "react";
import { getUserFromToken } from "../../../utils/functions.ts";
import SupportChatWindow from "./supportChatWindow.component.jsx";
import SupportAdminPanel from "./supportAdminPanel.component.jsx";

const SupportChatButton = () => {
    const endpoint = "https://www.fbxchange.com/ReactPHP/supportChat.php";

    const [user, setUser] = useState(null);
    const [openUserChat, setOpenUserChat] = useState(false);
    const [openAdminChat, setOpenAdminChat] = useState(false);
    const [openCount, setOpenCount] = useState(0);

    const isAdmin = useMemo(() => {
        return (
            String(user?.userContactLevel ?? "") === "1" ||
            String(user?.scout ?? "") === "1"
        );
    }, [user]);

    useEffect(() => {
        let mounted = true;

        const loadUser = async () => {
            try {
                const u = await getUserFromToken();
                if (mounted) {
                    setUser(u || null);
                }
            } catch (err) {
                console.log("support user load error", err);
                if (mounted) {
                    setUser(null);
                }
            }
        };

        loadUser();

        return () => {
            mounted = false;
        };
    }, []);

    const loadOpenCount = useCallback(async () => {
        if (!isAdmin) return;

        try {
            const res = await fetch(endpoint, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    scriptName: "getOpenSupportThreadsCount",
                }),
            });

            const data = await res.json();

            if (data?.success) {
                setOpenCount(Number(data?.openCount || 0));
            }
        } catch (err) {
            console.log("support count error", err);
        }
    }, [endpoint, isAdmin]);

    useEffect(() => {
        if (!isAdmin) return;

        loadOpenCount();

        if (openAdminChat) return;

        const interval = setInterval(() => {
            loadOpenCount();
        }, 60000);

        return () => clearInterval(interval);
    }, [isAdmin, openAdminChat, loadOpenCount]);

    if (!user) return null;

    return (
        <>
            <button
                type="button"
                className="rounded-circle shadow position-fixed border-0"
                style={{
                    bottom: "10px",
                    right: "10px",
                    width: "42px",
                    height: "42px",
                    zIndex: 99999,
                    fontWeight: 700,
                    fontSize: "18px",
                    backgroundColor: "#0d6efd",
                    color: "white",
                }}
                onClick={() => {
                    if (isAdmin) {
                        setOpenAdminChat((prev) => !prev);
                        setOpenUserChat(false);
                    } else {
                        setOpenUserChat((prev) => !prev);
                        setOpenAdminChat(false);
                    }
                }}
                title={isAdmin ? "Support Inbox" : "Customer Support"}
            >
                ?
                {isAdmin && openCount > 0 && (
                    <span
                        className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-warning text-dark"
                        style={{ fontSize: "11px" }}
                    >
                        {openCount}
                    </span>
                )}
            </button>

            {!isAdmin && openUserChat && (
                <SupportChatWindow
                    currentUser={user}
                    onClose={() => setOpenUserChat(false)}
                />
            )}

            {isAdmin && openAdminChat && (
                <SupportAdminPanel
                    currentUser={user}
                    onClose={() => setOpenAdminChat(false)}
                />
            )}
        </>
    );
};

export default SupportChatButton;
